import { Button } from "react-bootstrap";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/useTypedSelector";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { setRoutesDefinitive } from "../../infrastructure/redux/PlanningThunks";

export const DefinitiveButton = () => {
  const { t } = useTranslation("common");
  const { routes } = useAppSelector((state) => state.planning);
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const isAllRoutesDefinitive = useMemo(() => {
    return routes.every(
      (route) => route.status == "definitive" || route.status == "completed",
    );
  }, [routes]);

  const handleMakeDefinitive = async (definitive: boolean) => {
    setIsLoading(true);
    const status = definitive ? "definitive" : "draft";
    try {
      await dispatch(
        setRoutesDefinitive({
          routeIds: routes.map((route) => route.id),
          status,
        }),
      ).unwrap();
    } finally {
      setIsLoading(false);
    }
  };

  if (routes.length === 0) {
    return null;
  }

  return (
    <Button
      variant={isAllRoutesDefinitive ? "secondary" : "primary"}
      className="btn-sm"
      onClick={() => {
        void handleMakeDefinitive(!isAllRoutesDefinitive);
      }}
      disabled={isLoading}
    >
      {isLoading
        ? t("Making definitive...")
        : isAllRoutesDefinitive
          ? t("Make not definitive")
          : t("Make definitive")}
    </Button>
  );
};
